import React from 'react';
import { useSelector } from 'react-redux';
import { Menu } from 'lucide-react';
import { RootState } from 'store';
import { NavbarConfig } from '../../types/navigation.types';
import NavbarAction from './NavbarAction';
import SearchBar from './SearchBar';
import useIsMobile from 'hooks/useIsMobile';

interface NavbarProps {
  config: NavbarConfig;
  setShowSidebar: (show: boolean) => void;
}

const Navbar: React.FC<NavbarProps> = ({ config, setShowSidebar }) => {
  const { user, isAuthenticated } = useSelector(
    (state: RootState) => state.auth
  );

  const isMobile = useIsMobile();
  // const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // // Update isMobile based on window resize
  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsMobile(window.innerWidth <= 768);
  //   };

  //   window.addEventListener('resize', handleResize);

  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, []);

  return (
    <div className="flex items-center justify-between h-14 bg-background lg:rounded-lg p-3 sticky top-0 z-50">
      {isMobile ? (
        <Menu
          className="text-primary"
          onClick={() => setShowSidebar(true)}
        />
      ) : (
        config.search.enabled && (
          <SearchBar placeholder={config.search.placeholder} />
        )
      )}

      <div className="flex items-center space-x-4">
        {config.actions.map((action) => {
          if (action.id === 'files' && !isAuthenticated) {
            return null;
          }
          if (action.id === 'login' && isAuthenticated) {
            return (
              <NavbarAction
                key="avatar"
                action={{
                  id: 'avatar',
                  type: 'avatar',
                  user: user, // Pass user details
                }}
              />
            );
          }

          if (action.id !== 'login') {
            return <NavbarAction key={action.id} action={action} />;
          }

          return null;
        })}
        {!isAuthenticated && (
          <NavbarAction
            key="login"
            action={{ ...config.actions.find((a) => a.id === 'login')! }}
          />
        )}
      </div>
    </div>
  );
};

export default Navbar;
